/// <reference path="../../../../typings/index.d.ts" />
///<reference path="yield-management-strategy.module.ts"/>


module Meevo.Plugins.YieldManagementStrategy {
    import CoSearchType = Meevo.Model.CoSearchType;
    import CoSearchResultsFilter = Meevo.Model.CoSearchResultsFilter;

    interface ISearchContextCriteria {
        isCOSearch?: boolean;
        coSearchType?: CoSearchType;
        coSearchResultFilter?: CoSearchResultsFilter;
    }

    class YieldManagementStrategyController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService',
            '$translate'];

        searchContextCriteria: ISearchContextCriteria;

        get searchNoun() {
            return Meevo.Model.NounEnum.YieldManagementStrategy;
        }

        get baseEndpoint() {
            return this.appSettings.API_ENDPOINTS.yieldManagementStrategy;
        }

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected securityService: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $scope: angular.IScope,
                    protected $state: any,
                    protected contextParams: Meevo.IContextParams,
                    protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $translate: angular.translate.ITranslateService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.searchContextCriteria = {
                isCOSearch: this.identityService.inCentralOfficeMode(),
                coSearchType: this.identityService.inCentralOfficeMode() ? CoSearchType.CentralOffice : CoSearchType.Location,
                coSearchResultFilter: CoSearchResultsFilter.All,
            };
        }


        /**
         * Creates the context for editing/adding an item.
         * @return {}
         */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.MANAGEMENT_YIELDMANAGEMENTSTRATEGY).then(() => {
                this.busyService.stop();
                this.context = new YieldManagementStrategyContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.$scope, this.busyService);
                this.context.activate(this.selectedItemId, null, this.asLocationId);
                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
            }).catch(() => {
                this.busyService.stop();
            });
        }

        onRouteActive() {
            if (this.context && this.context.selectedSection && this.context.selectedSection.model) {
                this.context.reloadSelectedSection();
            }
        }
    }

    angular.module('meevo.plugins.yieldManagementStrategy')
        .controller('meevo.plugins.yieldManagementStrategy.YieldManagementStrategyController', YieldManagementStrategyController);
}
